import {createRouter, createWebHistory, createWebHashHistory} from 'vue-router'
import DashboardsIndex from './components/Dashboard.vue';
import DashboardsAlerts from './components/DashboardAlerts.vue';
import DashboardsAlertsServices from './components/DashboardAlertsServices.vue';
import DashboardsTacticals from './components/DashboardTacticalWidgets.vue';
import DashboardsStatuspages from './components/DashboardStatuspages.vue';
import DashboardsStatuspagegroups from './components/DashboardStatuspagegroups.vue';
import ServicesIndex from './components/services/ServiceIndex.vue';
import ServicesDetails from './components/services/ServicesDetails.vue';
import HostsIndex from './components/hosts/HostsIndex.vue';
import HostsDetails from './components/hosts/HostsDetails.vue';
import DowntimesHosts from './components/downtimes/DowntimesHosts.vue';
import DowntimesHostsAdd from "./components/downtimes/DowntimesHostsAdd.vue";
import Login from './components/Login.vue';
import Root from './components/Root.vue';
import App from './views/App.vue';
import DowntimesServices from "./components/downtimes/DowntimesServices.vue";
import DowntimesServicesAdd from "./components/downtimes/DowntimesServicesAdd.vue";
import StatuspagesIndex from './components/statuspages/StatuspagesIndex.vue';
import StatuspagesDetails from './components/statuspages/StatuspagesDetails.vue';
import StatuspagegroupsDetails from './components/statuspagegroups/StatuspagegroupsDetails.vue';
import ServicegroupsIndex from './components/servicegroups/ServicegroupsIndex.vue';
import ServicegroupsDetails from './components/servicegroups/ServicegroupsDetails.vue';
import HostgroupsIndex from './components/hostgroups/HostgroupsIndex.vue';
import HostgroupsDetails from './components/hostgroups/HostgroupsDetails.vue';
import ContactInfo from './components/ContactInfo.vue';
import ResourcesIndex from './components/ResourcesIndex.vue';
import ResourceGroupInfo from './components/ResourceGroupInfo.vue';
import ResourcegroupsIndex from './components/ResourcegroupsIndex.vue';
import MailinglistInfo from './components/MailinglistInfo.vue';
import SlasIndex from './components/slas/SlasIndex.vue';
import SlasDetails from './components/slas/SlasDetails.vue';


const router = createRouter({
    history: createWebHistory(),
   // hash: createWebHashHistory(),
    routes: [
        {
            path: '',
            name: 'root',
            component: Root
        },
        {
            path: '/',
            name: 'app',
            component: App
        },
        {
            path: '/dashboards/index',
            name: 'dashboardsIndex',
            component: DashboardsIndex
        },
        {
            path: '/dashboards/tacticals',
            name: 'dashboardsTacticals',
            component: DashboardsTacticals
        },
        {
            path: '/dashboards/alerts',
            name: 'dashboardsAlerts',
            component: DashboardsAlerts
        },
        {
            path: '/dashboards/alertServices',
            name: 'dashboardsAlertsServices',
            component: DashboardsAlertsServices
        },
        {
            path: '/dashboards/statuspages',
            name: 'dashboardsStatuspages',
            component: DashboardsStatuspages
        },
        {
            path: '/dashboards/statuspagegroups',
            name: 'dashboardsStatuspagegroups',
            component: DashboardsStatuspagegroups
        },
        {
            path: '/services/index',
            name: 'servicesIndex',
            props: true,
            component: ServicesIndex
        },
        {
            path: '/services/index',//'/services/index/:filter',
            name: 'servicesIndexFilter',
            props: true,
            component: ServicesIndex
        },
        {
            path: '/services/details/:id',
            name: 'servicesDetails',
            component: ServicesDetails
        },
        {
            path: '/hosts/index',
            name: 'hostsIndex',
           props: true,
            component: HostsIndex
        },
        {
            path: '/hosts/index',
            name: 'hostsIndexFilter',
            props: true,
            component: HostsIndex
        },
        {
            path: '/hosts/details/:id',
            name: 'hostsDetails',
            component: HostsDetails
        },
        {
            path: '/downtimes/hosts',
            name: 'downtimesHost',
            component: DowntimesHosts
        },
        {
            path: '/downtimes/hosts_add',
            name: 'downtimesHostAdd',
            component: DowntimesHostsAdd
        },
        {
            path: '/downtimes/services',
            name: 'downtimesService',
            component: DowntimesServices
        },
        {
            path: '/downtimes/services_add',
            name: 'downtimesServiceAdd',
            component: DowntimesServicesAdd
        },
        {
            path: '/statuspages/index',
            name: 'statuspagesIndex',
            component: StatuspagesIndex
        },
        {
            path: '/statuspages/details/:id',
            name: 'statuspagesDetails',
            component: StatuspagesDetails
        },
        {
            path: '/statuspages/details/:id',
            name: 'statuspagesDetails',
            component: StatuspagesDetails
        },
        {
            path: '/statuspagegroups/details/:id',
            name: 'statuspagegroupsDetails',
            component: StatuspagegroupsDetails
        },
        {
            path: '/servicegroups/index',
            name: 'servicegroupsIndex',
            component: ServicegroupsIndex
        },
        {
            path: '/servicegroups/details/:id',
            name: 'servicegroupsDetails',
             props: true,
            component: ServicegroupsDetails
        },
        {
            path: '/hostgroups/index',
            name: 'hostgroupsIndex',
            component: HostgroupsIndex
        },
        {
            path: '/hostgroups/details/:id',
            name: 'hostgroupsDetails',
            props: true,
            component: HostgroupsDetails
        },
        {
            path: '/contact/info',
            name: 'contactInfo',
            props: true,
            component: ContactInfo
        },
        {
            path: '/resources/index',
            name: 'resourcesIndex',
            component: ResourcesIndex
        },
        {
            path: '/resources/resourceGroup/:id',
            name: 'resourceGroupInfo',
            component: ResourceGroupInfo
        },
        {
            path: '/resourcegroups/index',
            name: 'resourcegroupsIndex',
            component: ResourcegroupsIndex
        },
        {
            path: '/resourcegroups/mailinglist/:id',
            name: 'mailinglistInfo',
            component: MailinglistInfo
        },
        {
            path: '/slas/index',
            name: 'slasIndex',
            component: SlasIndex
        },
        {
            path: '/slas/details/:id',
            name: 'slasDetails',
            component: SlasDetails
        },
        {
            path: '',//'/users/login',
            name: 'login',
            component: Login
        }
    ],
});
export default router;
